import { toPng } from "html-to-image";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const DOWNLOAD_ERROR = "Download failed. Please try again.";

const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const reportFilename = (start, end, ext) => `DaLilShop_Report_${start}_to_${end}.${ext}`;

export async function downloadReport(fmt, start, end) {
  try {
    const res = await api.get(`/reports/export/${fmt}`, { params: { start, end }, responseType: "blob" });
    saveBlob(res.data, reportFilename(start, end, fmt));
    return true;
  } catch {
    toast.error(DOWNLOAD_ERROR);
    return false;
  }
}

export async function downloadNodePng(node, filename) {
  try {
    const dataUrl = await toPng(node, {
      backgroundColor: "#ffffff",
      pixelRatio: 2,
      cacheBust: true,
      filter: (el) => !(el instanceof HTMLElement && el.dataset?.exportIgnore === "true"),
    });
    const blob = await (await fetch(dataUrl)).blob();
    saveBlob(blob, filename);
  } catch {
    toast.error(DOWNLOAD_ERROR);
  }
}
